import BaseStore from './BaseStore';
import rp from 'request-promise';
import config from '../config';
// import { notification } from 'antd'
import { getToken } from '../components/Token';
import { getTenantHeaders } from '../components/TenantHeaders';
import { clearLocalStorage } from '../utils/common';
import moment from 'moment';

export class VitalSignStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      // vitalsign: {},
      since: 7,
      heartrate: 0,
      temperature: 0,
      spo2: 0,
      respirationRate: 0,
      bloodPressure: {
        systolic: 0,
        diastolic: 0,
        heartrate: 0,
      },
      createdDate: null,
      chartHeartrate: [],
      chartTemperature: [],
      chartSpo2: [],
      chartBloodPressure: {},
      chartRespirationRate: [],
      loading: false,
    });
  }

  setSinceData(days) {
    this.since = days;
  }

  resetVitalSigns() {
    this.heartrate = 0;
    this.temperature = 0;
    this.spo2 = 0;
    this.respirationRate = 0;
    this.bloodPressure = {
      systolic: 0,
      diastolic: 0,
      heartrate: 0,
    };
  }

  async getLastVitalSign(patientId, date, query) {
    // const dateFormate =
    //   date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    const dateFormate = `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
    try {
      let url = `${config.api.url}/${config.api.version}/vitalsign/last/patient/${patientId}/date/${dateFormate}`;
      const res = await rp
        .get({
          uri: url,
          qs: query,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));

      if (res && res.statusCode === 200) {
        const data = res.body || {};
        if (query.heartrate) {
          this.heartrate = data['heartrate'];
        }
        if (query.temperature) {
          this.temperature = data['temperature'];
        }
        if (query.spo2) {
          this.spo2 = data['spo2'];
        }
        if (query.bloodPressure) {
          this.bloodPressure = data['bloodPressure'];
        }
        if (query.respirationRate) {
          this.respirationRate = data['respirationRate'];
        }
        this.createdDate = data['createdDate'];
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
    }
  }

  async getSummaryVitalSign(patientId, date, query) {
    const dateFormat = `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(
      -2,
    )}-${('0' + date.getDate()).slice(-2)}`;
    try {
      this.loading = true;
      let url = `${config.api.url}/${config.api.version}/vitalsign/summary/patient/${patientId}/date/${dateFormat}`;
      const res = await rp
        .get({
          uri: url,
          qs: query,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));

      if (res && res.statusCode === 200) {
        const data = res.body || {};
        if (query.heartrate) {
          this.chartHeartrate =
            this.since <= 7
              ? this.calcHeartRateChartData(data['heartrate'], dateFormat)
              : this.calcPeriodChartData(data['heartrate'], dateFormat);
        }
        if (query.temperature) {
          this.chartTemperature =
            this.since <= 7
              ? this.calcTemperatureChartData(data['temperature'], dateFormat)
              : this.calcPeriodChartData(data['temperature'], dateFormat, true);
        }
        if (query.spo2) {
          this.chartSpo2 =
            this.since <= 7
              ? this.calcSpo2ChartData(data['spo2'], dateFormat)
              : this.calcPeriodChartData(data['spo2'], dateFormat);
        }
        if (query.respirationRate) {
          this.chartRespirationRate =
            this.since <= 7
              ? this.calcRespirationRateChartData(data['respirationRate'], dateFormat)
              : this.calcPeriodChartData(data['respirationRate'], dateFormat);
        }
        if (query.bloodPressure) {
          const bloodPressure = this.calcBloodpressureChartData(data['bloodPressure'], dateFormat);
          const systolicMedian = this.calcPeriodChartData(data['bloodPressure'].systolic, dateFormat);
          const diastolicMedian = this.calcPeriodChartData(data['bloodPressure'].diastolic, dateFormat);

          this.chartBloodPressure = {
            systolic: this.since <= 7 ? bloodPressure.systolic : systolicMedian,
            diastolic: this.since <= 7 ? bloodPressure.diastolic : diastolicMedian,
          };
        }
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async createHeartRate(patientId, createdDate, heartrate) {
    this.loading = true;
    try {
      const detail = {
        patientId,
        heartrate,
        createdDate,
      };
      let url = `${config.api.url}/${config.api.version}/vitalsign/heartrate`;
      const res = await rp
        .post(url, {
          body: detail,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      console.log('error', err);
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async createBloodPressure(patientId, createdDate, bloodPressure) {
    this.loading = true;
    try {
      const detail = {
        patientId,
        bloodPressure: {
          systolic: bloodPressure.systolic,
          diastolic: bloodPressure.diastolic,
        },
        createdDate,
      };
      let url = `${config.api.url}/${config.api.version}/vitalsign/bloodpressure`;
      const res = await rp
        .post(url, {
          body: detail,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      console.log('error', err);
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async createSpo2(patientId, createdDate, spo2) {
    this.loading = true;
    try {
      const detail = {
        patientId,
        spo2,
        createdDate,
      };
      let url = `${config.api.url}/${config.api.version}/vitalsign/spo2`;
      const res = await rp
        .post(url, {
          body: detail,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      console.log('error', err);
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async createTemperature(patientId, createdDate, temperature) {
    this.loading = true;
    try {
      const detail = {
        patientId,
        temperature,
        createdDate,
      };
      let url = `${config.api.url}/${config.api.version}/vitalsign/temperature`;
      const res = await rp
        .post(url, {
          body: detail,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      console.log('error', err);
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async createRespirationRate(patientId, createdDate, respirationRate) {
    this.loading = true;
    try {
      const detail = {
        patientId,
        respirationRate,
        createdDate,
      };
      let url = `${config.api.url}/${config.api.version}/vitalsign/respirationrate`;
      const res = await rp
        .post(url, {
          body: detail,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      console.log('error', err);
      throw err;
    } finally {
      this.loading = false;
    }
  }

  getUTCDateTime(dateTime) {
    return dateTime.getTime() - dateTime.getTimezoneOffset() * 60 * 1000;
  }

  getDays = (date, days) => {
    const results = [];
    for (let i = 0; i < days; i++) {
      let d = new Date(date);
      d.setDate(d.getDate() - i);
      results.push(moment(d).format('YYYY-MM-DD'));
    }
    return results;
  };

  getMonths = (date, months) => {
    const results = [];
    for (let i = 0; i < months; i++) {
      let d = new Date(date);
      d.setMonth(d.getMonth() - i);
      const tmp = `${d.getFullYear()}-${('0' + (d.getMonth() + 1)).slice(-2)}`;
      results.push(tmp);
    }
    return results;
  };

  calcChartData = (datas, dateTimes, minmax = false) => {
    const dateWithOutValue = [];
    const dateWithValue = [];
    dateTimes.forEach((date) => {
      const dt = new Date(date);
      const dateUTC = this.getUTCDateTime(dt);
      const found = datas.filter((t) => t.date === date);
      if (minmax) {
        if (found.length === 0) {
          dateWithOutValue.push([dateUTC, null, null]);
        } else {
          found.forEach((f) => {
            dateWithValue.push(f.value);
          });
        }
      } else {
        if (found.length === 0) {
          dateWithOutValue.push([dateUTC, null]);
        } else {
          found.forEach((f) => {
            dateWithValue.push(f.value);
          });
        }
      }
    });

    const results = dateWithOutValue.concat(dateWithValue);
    return results.sort();
  };

  calcHeartRateChartData(datas, date) {
    let results = [];
    if (datas.length > 0) {
      const dateTimes = this.getDays(date, 7);
      // re format
      const heartrateDatas = datas.map((d) => {
        const dt = new Date(d.createdDate);
        const dateFormat = moment(dt).format('YYYY-MM-DD');
        const tmp = {
          date: dateFormat,
          value: [this.getUTCDateTime(dt), d.heartrate],
        };
        return tmp;
      });

      results = this.calcChartData(heartrateDatas, dateTimes);
    }
    return { data: results };
  }

  calcTemperatureChartData(datas, date) {
    let results = [];
    if (datas.length > 0) {
      const dateTimes = this.getDays(date, 7);
      // re format
      const temperatureDatas = datas.map((d) => {
        const dt = new Date(d.createdDate);
        const dateFormat = moment(dt).format('YYYY-MM-DD');
        const tmp = {
          date: dateFormat,
          value: [this.getUTCDateTime(dt), d.temperature],
        };
        return tmp;
      });
      results = this.calcChartData(temperatureDatas, dateTimes);
    }
    return { data: results };
  }

  calcBloodpressureChartData(data, date) {
    let systolic = [];
    let diastolic = [];

    if (data && (data.systolic.length > 0 || data.diastolic.length > 0)) {
      const dateTimes = this.getDays(date, 7);

      // re format systolic
      const systolicData = data.systolic.map((d) => {
        const dt = new Date(d.createdDate);
        const dateFormat = moment(dt).format('YYYY-MM-DD');
        const tmp = {
          date: dateFormat,
          value: [this.getUTCDateTime(dt), d.systolic],
        };
        return tmp;
      });

      // re format diastolic
      const diastolicData = data.diastolic.map((d) => {
        const dt = new Date(d.createdDate);
        const dateFormat = moment(dt).format('YYYY-MM-DD');
        const tmp = {
          date: dateFormat,
          value: [this.getUTCDateTime(dt), d.diastolic],
        };
        return tmp;
      });

      systolic = this.calcChartData(systolicData, dateTimes);
      diastolic = this.calcChartData(diastolicData, dateTimes);
    }
    return { systolic, diastolic };
  }

  calcSpo2ChartData(datas, date) {
    let results = [];
    if (datas.length > 0) {
      const dateTimes = this.getDays(date, this.since);
      // re format
      const spo2Datas = datas.map((d) => {
        const dt = new Date(d.createdDate);
        const dateFormat = moment(dt).format('YYYY-MM-DD');
        const tmp = {
          date: dateFormat,
          value: [this.getUTCDateTime(dt), d.spo2],
        };
        return tmp;
      });

      results = this.calcChartData(spo2Datas, dateTimes);
    }
    return { data: results };
  }

  calcPeriodChartData(datas, date, decimal = false) {
    let medianResults = [];
    let minmaxResults = [];
    if (datas && datas.length > 0) {
      const dateTimes = this.since < 365 ? this.getDays(date, this.since) : this.getMonths(date, 12);
      // re format
      const dataMedian = datas.map((d) => {
        const dt = moment(new Date(d.createdDate)).startOf('day').toDate();
        const median = decimal ? d.median.toFixed(1) : Math.round(d.median);
        const tmp = {
          date: d.createdDate,
          value: [this.getUTCDateTime(dt), +median],
        };
        return tmp;
      });

      const dataMinMax = datas.map((d) => {
        const dt = moment(new Date(d.createdDate)).startOf('day').toDate();
        const min = decimal ? d.min.toFixed(1) : Math.round(d.min);
        const max = decimal ? d.max.toFixed(1) : Math.round(d.max);
        const tmp = {
          date: d.createdDate,
          value:
            d.min === d.median && d.max === d.median
              ? [this.getUTCDateTime(dt), null, null]
              : [this.getUTCDateTime(dt), +min, +max],
        };
        return tmp;
      });
      medianResults = this.calcChartData(dataMedian, dateTimes);
      minmaxResults = this.calcChartData(dataMinMax, dateTimes, true);
    }
    return {
      data: medianResults,
      minmax: minmaxResults,
    };
  }

  calcRespirationRateChartData(datas, date) {
    let results = [];
    if (datas.length > 0) {
      const dateTimes = this.getDays(date, this.since);
      // re format
      const respirationRateDatas = datas.map((d) => {
        const dt = new Date(d.createdDate);
        const dateFormat = moment(dt).format('YYYY-MM-DD');
        const tmp = {
          date: dateFormat,
          value: [this.getUTCDateTime(dt), d.respirationRate],
        };
        return tmp;
      });

      results = this.calcChartData(respirationRateDatas, dateTimes);
    }
    return { data: results };
    // let results = [];
    // if (datas.length > 0) {
    //   const dateTimes = this.getDays(date, 7);
    //   // re format
    //   const respirationRateDatas = datas.map((d) => {
    //     const dt = new Date(d.createdDate);
    //     const dateFormat = moment(dt).format("YYYY-MM-DD");
    //     const tmp = {
    //       date: dateFormat,
    //       value: [this.getUTCDateTime(dt), d.respirationRate],
    //     };
    //     return tmp;
    //   });

    //   results = this.calcChartData(respirationRateDatas, dateTimes);
    // }
    // return results;
  }
}
export default new VitalSignStore();
